import withApollo from 'nextDir/enhancers/page/withApollo';

import { JobsByLocationPage } from 'src/modules/Seo/JobsByLocationPage';

export default withApollo(JobsByLocationPage);
